import type { CustomTagProps } from 'rc-select/lib/BaseSelect';
import { ConfigurationRuleScopeEntityType } from '@ydistri/api-sdk';
import React from 'react';
import MultiselectTag from './MultiselectTag';
import { getScopeErrorText } from './scopeLib';
import { MAIN_SCOPE_PRIORITY } from './scopeUtilsLib';

interface MultiselectScopeTagProps extends CustomTagProps {
  entityType: ConfigurationRuleScopeEntityType;
  tagWarnings?: Record<number, React.ReactNode | undefined>;
  /** The selected ids the server's report says are out of the general scope. */
  missingIds?: number[];
}

const MultiselectScopeTag: React.FC<MultiselectScopeTagProps> = ({
  entityType,
  tagWarnings,
  missingIds,
  label,
  value,
  closable,
  onClose,
  disabled,
}) => {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- Ant tag values are the numeric option IDs supplied by this feature
  const entityId = value as unknown as number;
  const error = getScopeErrorText(
    MAIN_SCOPE_PRIORITY,
    missingIds?.includes(entityId) ?? false,
    entityType,
  );

  return (
    <MultiselectTag
      entityType={entityType}
      closable={closable}
      onClose={onClose}
      error={error}
      warning={error ? undefined : tagWarnings?.[entityId]}
      label={label}
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- forwarded from Ant's CustomTagProps contract
      value={value}
      disabled={disabled}
      entityId={entityId}
    />
  );
};

export default MultiselectScopeTag;
